import * as React from "react";
import styled from "@mui/material/styles/styled";

import NoDiseaseIcon from "../../../assets/noDiseases.svg";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const NoDiseasesIconView = styled("div")(({ theme }) => ({
  marginTop: "25%",
  display: "flex",
  flexDirection: "column",
}));

const NoDiseasesText = styled("div")(({ theme }) => ({
  marginTop: "20px",
  fontSize: "16px",
  textAlign: "center",
  color: KahunColorMap.DefaultLight,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NoDiseasesIconProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const NoDiseasesIcon = ({ ...props }: NoDiseasesIconProps) => {
  return (
    <NoDiseasesIconView>
      <img src={NoDiseaseIcon} alt={"No Diseases"} height={"150px"} />
      <NoDiseasesText>
        {"Insufficient patient data."} <br />
        {"Please add clinical findings to view results"}
      </NoDiseasesText>
    </NoDiseasesIconView>
  );
};
